export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('getNumberLabels', (number, labels) => {
        number = Math.abs(number) % 100; 
        var num = number % 10;
        if(number > 10 && number < 20) return labels[2]; 
        if(num > 1 && num < 5) return labels[1];
        if(num == 1) return labels[0]; 
        return labels[2];
    })
})